// @ts-nocheck
import { get } from "@insite/client-framework/Services/ApiService";
import { SendInvoiceEmailApiParameter } from "@store/Framework/Store/Store/CommonHandlers/SendInvoiceEmail";

export const customInvoicesServiceUrl = "/api/v1/custom/invoices";

export function getInvoiceByEmail(parameter: SendInvoiceEmailApiParameter) {
    return get<void>(`${customInvoicesServiceUrl}/${parameter.invoiceId}/email`);
}
